<template lang="pug">
div
  v-btn(
    v-if="isCopiable"
    icon
    small
    @click="copyToClipboard"
  )
    v-icon(small) mdi-content-copy

  v-chip.x-chip(
    v-if="useChip"
    :color="cellColor || 'primary'"
    :link="!!cellLink"
  )
    | {{ text }}

  span(v-else) {{ text }}

  //- x-chip(
  //-   :value="!!(useBadge && value)",
  //-   :link="!!primaryLink",
  //-   :color="cellColor || 'primary'",
  //-   @actionPerformed="call(primaryLink)"
  //- )
  //-   template(v-if="useIcon")

  //-   template(v-else-if="primaryLink && !useBadge && primaryLink.href")
  //-     a.x-link(
  //-       :target="primaryLink.href"
  //-       :href="primaryLink.href"
  //-     )
  //-       | {{ value }}

  //-   template(v-else-if="primaryLink && !useBadge")
  //-     router-link.x-link(
  //-       is="a",
  //-       :class="useBadge ? null : cellClass",
  //-       @click.stop="call(primaryLink)"
  //-     )
  //-       | {{ value }}

  //-   template(v-else)
  //-     div(
  //-       :class="useBadge ? 'x-badge-cell' : cellClass"
  //-     )
  //-       | {{ value }}

  v-snackbar(
    v-if="isCopiable"
    v-model="snackbar" :timeout="2000"
  )
    span.success--text Texto copiado para a área de transferência.

</template>

<style lang="scss">
.x-chip {
  height: 20px !important;
  padding: 6px;
  * {
    min-height: 0;
  }
}
</style>

<script>
import { hasRel } from '@/helpers/rels'

export default {
  props: {
    /**
     * Valor da célula.
     */
    value: { validator: () => true },

    /**
     * Propriedades do objeto representado a coluna da célula.
     * Exemplo:
     *  {
     *    "value": <Object>,
     *    ...
     *  }
     */
    col: { validator: () => true },

    /**
     * Propriedades do objeto representado pela célula.
     * Exemplo:
     *  {
     *    "value": <Object>,
     *    ...
     *  }
     */
    cell: { validator: () => true },

    /**
     * Link primário da célula.
     */
    cellLink: { validator: () => true },

    cellClass: { validator: () => true },
    cellColor: { validator: () => true },
    cellStyle: { validator: () => true },
  },

  data: () => ({
    snackbar: false,
  }),

  computed: {

    // Preview ativa a exibição de um texto reduzido, com uma ação para copiar o texto
    // inteiro para a área de transferência.
    isPreview() {
      return hasRel(this.cell, 'Preview') || hasRel(this.col?.header, 'Preview')
    },

    isCopiable() {
      return this.isPreview
    },

    useChip() {
      return this.col.useBadge
    },

    text() {
      if (this.isPreview) {
        let value = this.value?.toString()?.trim() || ''
        return value.length > 50 ? value.substring(0, 50) + '...' : value
      }
      return this.value
    },

  },

  methods: {
    /*copyToClipboard() {
      navigator.clipboard.writeText(this.value);
      this.snackbar = true
    },*/

    copyToClipboard(content) {
      const textarea = document.createElement('textarea');
      textarea.value = this.value;

      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      textarea.style.opacity = '0';

      document.body.appendChild(textarea);
      textarea.select();

      try {
        const ok = document.execCommand('copy');
        if (ok) {
          this.snackbar = true;
        } else {
          console.warn('Falha ao copiar');
        }
      } catch (err) {
        console.error('Erro ao copiar: ', err);
      }

      document.body.removeChild(textarea);
    },
  }
}
</script>

